// frontend/src/components/EdaPrepare/EdaPrepareSummary.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const EdaPrepareSummary: React.FC<Props> = ({ analysis }) => {
  const trainConfig = analysis?.train_config?.config;

  if (!trainConfig) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        borderRadius: '12px',
        padding: '20px',
        border: '1px solid #1a4a7a',
        marginBottom: '24px'
      }}>
        <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>
          📋 Resumo da Preparação
        </h3>
        <div style={{ fontSize: '14px', color: '#8899aa' }}>
          Sem configuração de treino registrada.
        </div>
      </div>
    );
  }

  const fields = Object.entries(trainConfig);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px'
    }}>
      <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>
        📋 Resumo da Preparação
      </h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
        {fields.map(([key, value]) => (
          <div key={key}>
            <div style={{ fontSize: '12px', color: '#8899aa' }}>{key}</div>
            <div style={{ fontSize: '16px', color: '#ffffff' }}>{renderValue(value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};